import { clsx } from 'clsx'

import { Prose } from '~/portal/components/ProseWrapper'
import { Footer } from '~/portal/types/portal'
import { sanitizeRichContentHtml } from '~/portal/utils/shared/sanitizeHtml'

interface ConsumerFooterProps {
  footer: Footer
  isLandingPage?: boolean
}

export const ConsumerFooter = ({ footer, isLandingPage }: ConsumerFooterProps) => {
  const html = sanitizeRichContentHtml(footer.content || '')

  return (
    <footer className={clsx('sp-footer w-full pt-8 md:pt-12 dark:bg-neutral-98', isLandingPage ? 'bg-(--sp-color-surface-sunken) dark:bg-(--sp-color-surface)' : 'bg-(--sp-color-surface)')}>
      <div className="sp-footer-border w-full">
        <div
          data-testid="consumer-footer-html"
          className={clsx(
            'w-full px-6 py-6 md:px-15 md:py-10',
            !isLandingPage && 'border-t border-t-(--sp-color-border-subtle)',
            'dark:border-t dark:border-t-(--sp-color-border-subtle)',
            'bg-(--sp-color-surface)',
          )}
        >
          <Prose isLandingPage={isLandingPage}>
            <div dangerouslySetInnerHTML={{ __html: html }} />
          </Prose>
        </div>
      </div>
    </footer>
  )
}
